<section id="ngx-datatable-filter">
    <div class="row">
      <div class="col-12"></div>
      <div class="col-12">
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <fieldset class="form-group">
                <div class="row align-items-end mt-0 pagination-body">
                  <div class="d-flex  col-12 col-sm-12 col-md-6 col-lg-6 mt-1 mb-1 date-filter">
                    <div class=" mr-2">
                      <label>From Date</label>
                      <input type="date" [(ngModel)]="fromDate" class="form-control" (change)="getStartDate($event)">
                    </div>
                    <div class=" mr-2">
                      <label>To Date</label>
                      <input [(ngModel)]="toDate" type="date" class="form-control" (change)="getEndDate($event)">
                    </div>
                  </div>
                  <div class="col-12 col-sm-12 col-md-6 col-lg-6 mt-2 mb-1">
                    <div class="row-flex">
                      <div class="col-flex-2 mb-1 position-relative">
                        <input id="ngx-filter-ref"
                          class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
                          type="text" placeholder="Search" />
                        <button class="btn search-btn glow position-absolute">
                          <i class="ft-search text-white cursor-pointer"></i>
                        </button>
                      </div>
                      <div class="col-flex-2 mb-1">
                        <button class="btn btn-primary btn-block users-list-clear glow mb-0" >Reset
                          <i class="ft-filter text-white cursor-pointer"></i>
                        </button>
                      </div>
                      <div class="col-flex-2 mb-1"
                        *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                        <button type="reset" class="btn btn-primary btn-block users-list-clear glow mb-0"
                          (click)="openModalLeave(myModal,'','')" placement="top" ngbTooltip="Add New">
                          +
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col">
                    <button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Leave Guideline</button>
                  </div>
                </div>
                <div class="col-12">
                  <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50"
                [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows" [count]="page.totalPages" ></ngx-datatable>
                </div>
              </fieldset>
              <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50"
                [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows" [scrollbarH]="true"
                [columns]="columns" [count]="page.totalPages" [externalPaging]="true">
                
                <ngx-datatable-column name="Date" prop="date" [width]="30">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <div class="d-flex align-items-center">
                      <div class="cell-line-height cursor-pointer">
                        <p class="font-medium-1 line-height-1 mb-0">
                          {{ row?.created_at |customDate }}
                        </p>
                      </div>
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Title" prop="title" [width]="60">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <div class="d-flex align-items-center">
                      <div class="cell-line-height cursor-pointer">
                        <p class="font-medium-1 line-height-1 mb-0">
                          {{ row?.title }}
                        </p>
                      </div>
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="From-To" prop="from" [width]="80">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                      {{row?.from }} - {{row?.to}}
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Transferred " prop="transferred_to" [width]="20">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                     {{row?.transferred_to}}
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Status" prop="status" [width]="20">
                  
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <p >
                      <span *ngIf="row?.status[0]?.displayname == 'Open'"
                                  [ngClass]="{'bg-light-success badge badge-pill':row?.status[0]?.displayname == 'Open'}">
                                  {{row?.status[0]?.displayname}}
                                </span>
                                <span *ngIf="row?.status[0]?.displayname == 'In-Progress'"
                                  [ngClass]="{'bg-light-warning badge badge-pill':row?.status[0]?.displayname == 'In-Progress'}">
                                  {{row?.status[0]?.displayname}}
                                </span>
                                <span *ngIf="row?.status[0]?.displayname == 'Closed'"
                                  [ngClass]="{'bg-light-danger badge badge-pill':row?.status[0]?.displayname == 'Closed'}">
                                  {{row?.status[0]?.displayname}}
                                </span>
                    </p>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Request  " prop="body" [width]="20">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                     <p placement="left" ngbTooltip="click to view request info" (click)="openModalView(myModal22,row?.body,'body')">Link</p>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Reply " prop="admin_notes" [width]="20">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <p *ngIf="row?.admin_notes" placement="left" ngbTooltip="click to view reply info" (click)="openModalView(myModal22,row?.admin_notes,'admin_notes')">Link</p>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Action " [width]="20">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <span *ngIf="row?.status[0]?.name == 'open'"><i class="ft-edit text primary cursor-pointer" (click)="openModalLeave(myModal,row?._id,row)"></i></span>
                  </ng-template>
                </ngx-datatable-column>
                <!-- <ngx-datatable-column name="Leave Info" prop="body" [width]="100">
                    <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                        <p id="p-tag" [innerHTML]="row?.body"></p>
                    </ng-template>
                </ngx-datatable-column> -->
  
                <!-- <ngx-datatable-column name="Actions" [width]="80"
                  *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <i mat-button [matMenuTriggerFor]="menu1"
                      class="ft-more-vertical text-primary cursor-pointer mr-2"></i>
  
                    <mat-menu #menu1="matMenu">
                      <button mat-menu-item (click)="editDiscussion(row)">Edit</button>                     
                      <button mat-menu-item (click)="Delete(row._id)">Delete</button>
                    </mat-menu>
                  </ng-template>
                </ngx-datatable-column> -->
              </ngx-datatable>
              <!-- ngx-datatable-filter -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="d-flex justify-content-between align-items-center">
    <ngx-spinner></ngx-spinner>
    </div>
  <!--------------  Popup ------------------------------------------->
<div>
	<ng-template #myModal let-modal>
		<div class="modal-header">
			<h4 class="modal-title">Leave</h4>
			<button type="button" class="close" (click)="modal.dismiss()">
				<span>&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<form>
				<div class="form-group">
          <label>From Date</label>
          <input type="date" class="form-control" [formControl]="from_date" [min]="min_date" [max]="max_date" [ngModel]="task_leave_model.from_date | date: 'yyyy-MM-dd'" (ngModelChange)="updateBody()" >
        </div>
        <div class="form-group">
          <label>To Date</label>
          <input type="date" class="form-control" [formControl]="to_date" [min]="min_date" [max]="max_date" [ngModel]="task_leave_model.to_date | date: 'yyyy-MM-dd'" (ngModelChange)="updateBody()">
        </div>
        <div class="form-group">
          <label>Title</label>
					<input type="text" class="form-control" [formControl]="title" [(ngModel)]="task_leave_model.title"  [ngModelOptions]="{standalone: true}" (ngModelChange)="updateBody()">
        </div>
        <div class="form-group">
          <label>Knowledge Transafer To</label>
          <ng-select
				  [items]="emp_list"
				  bindLabel="userName"
				  bindValue="userId"
				  placeholder="Select user"
				  [(ngModel)]="selected_emp"
				  [ngModelOptions]="{ standalone: true }"
				  (change)="getEmpId($event)"
				>
				</ng-select>
        </div>
        <div class="form-group">
          <label>Body</label>
					<textarea name="body" id="body" cols="30" rows="17" class="form-control" [(ngModel)]="task_leave_model.body"  [ngModelOptions]="{standalone: true}" readonly></textarea>
        </div>
			</form>
			
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
			<button type="button" class="btn btn-primary" (click)="submit()">Submit</button>

		  </div>
	</ng-template>
</div>

  <!-------------- Request And Reply  Popup ------------------------------------------->
  <div>
    <ng-template #myModal22 let-modal>
      <div class="modal-header">
        <h4 class="modal-title" *ngIf="request_info">Leave Request Info</h4>
        <h4 class="modal-title" *ngIf="reply_info">Leave Reply Info</h4>

        <button type="button" class="close" (click)="modal.dismiss()">
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="d-flex" *ngIf="request_info">
          <p class="request-box">Request Info :</p>
          <p [innerHTML]="request_info"></p>
        </div>
        <div class="d-flex" *ngIf="reply_info">
          <p class="reply-box">Reply Info :</p>
          <p [innerText]="reply_info"></p>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
        </div>
    </ng-template>
  </div>
